import Link from 'next/link'
import * as React from 'react'

import { MENU_LINKS } from '@/constant/siteConstants'
import { cn } from '@/lib/utils'
import { usePathname } from '@/state/useGlobalState'

type TheMenuProps = {
  className?: string
}

export default function TheMenu({ className }: TheMenuProps) {
  const pathname = usePathname()
  return (
    <div
      id='TheMenu'
      className={cn(
        'flex flex-col justify-between px-4 py-6',
        'h-[var(--menu-height)] w-full overflow-y-scroll',
        'vM:static vM:h-full vM:w-[var(--menu-width)] vM:justify-end vM:py-4',
        'bg-black text-white',
        className,
      )}
    >
      {/* LINKS */}
      <nav className='mb-7'>
        <ul className='text-reg'>
          {MENU_LINKS.map(({ href, label, description }) => {
            const isActive = pathname === href
            const isExternal = href.startsWith('http')
            const LinkEl = isExternal ? 'a' : Link
            const targetProps = isExternal
              ? { target: '_blank', rel: 'noopener noreferrer' }
              : {}
            return (
              <li key={href} className='mb-5 last:mb-0'>
                <LinkEl
                  className={cn('menu--link', isActive && '-active')}
                  href={href}
                  {...targetProps}
                >
                  {isExternal && '↗ '}
                  {label}
                  {description && (
                    <>
                      <br />
                      <span className='opacity-50'>{description}</span>
                    </>
                  )}
                </LinkEl>
              </li>
            )
          })}
        </ul>
      </nav>

      <footer className='p--small'>
        <p className='mb-2'>
          <a
            className='opacity-50 hover:opacity-100'
            href='mailto:be@benjaminelwyn.com'
          >
            be@benjaminelwyn.com
          </a>
        </p>
        <p className='mb-2'>
          <a
            className='opacity-50 hover:opacity-100'
            href='https://instagram.com/elwynco'
            target='_blank'
            rel='noopener noreferrer'
          >
            instagram
          </a>
        </p>
        <p>
          <a
            className='opacity-50 hover:opacity-100'
            href='https://elwyn.co'
            target='_blank'
            rel='noopener noreferrer'
          >
            site by ben elwyn
          </a>
        </p>
      </footer>
    </div>
  )
}
